/*
 * @Author: HKuaiyin FE Chain
 * @Date: 2020-11-18 15:35:33
 * @Description: 声明根实例方法，以便节点组件调用
 * @FilePath: /kuaiyin-h5/src/index.js
 */

import handleTaskMethods from './handleTask';
import handleModalMethods from './handleModal';
import { versionCompare } from '@/lib/common';

// 埋点方法
import { trackClick } from '@/lib/track';
import historyTaskMethods from './historyTask';

export default {
	/**
	 * @description: 初始化 store 状态
	 */

	initStore() {
		// 获取客户端信息
		const {
			location: { pathname },
		} = window;
		const inValidPathName = ['/privacy_protocol', '/agreement', '/third-sdk-list'];

		if (!inValidPathName.includes(pathname)) {
			this.$store.dispatch('getClient');
		}
	},

	/**
	 * @description: 任务处理方法 适用于博深任务福利体系的任务处理 v2.0.0
	 * @param { Object } task 具体的任务对象
	 * @param { Object } params - 任务处理需要的参数
	 * @summary link_type - 跳转类型；1：本地跳转；2：外部跳转，可能会弹出免责声明；
	 */

	async handleTask(task, params) {
		const { task_belong, task_type, video_model, stay_reward_time, progress_status } = task;
		const { activityPosition } = params;

		// 更新全局活动入口位置
		this.$store.commit('updateActivityPos', activityPosition);

		switch (task_belong) {
			case 'jump': // 不可完成跳转任务
				this.jumpLink(task);
				break;
			case 'jump_reward': // 可完成跳转任务
				this.jumpLink(task);
				break;
			// eslint-disable-next-line no-case-declarations
			case 'jump_reward_time': // 可完成跳转任务(通过跳出页面时间判断任务完成状态)
				this.jumpLink(task);

				if (+progress_status === 3) return;

				const { welfare } = this.$store.state;
				this.$store.commit('welfare/task/setLeaveTime', Date.now());

				const limitTime = stay_reward_time || 5000;
				this.$store.commit('welfare/task/setLeaveRewardTime', limitTime);

				welfare.task.leaveTimer = setTimeout(() => {
					console.log('通知服务端跳转任务完成!', Date.now() - this.$store.state.welfare.task.leavePageTime);

					// 通知服务端跳转任务完成
					this.$post(this.$api.UPDATE_TASK_PROGRESS_API, { taskType: task_type });
					clearTimeout(welfare.task.leaveTimer);
					welfare.task.leaveTimer = null;

					console.log('更新此条任状态!');
					// 更新此条任务状态, 解决通知服务端和刷新页面数据是异步操作问题
					this.refreshTaskStatus(task);
				}, limitTime);
				break;
			case 'modal': // 不可完成弹窗任务
				this.handleModal(task);
				break;
			case 'modal_reward': // 可完成弹窗任务
				this.handleModal(task);
				break;
			case 'modal_reward_time': // 可完成弹窗任务(通过弹出弹窗时间判断任务完成状态)
				this.handleModal(task);
				break;
			// eslint-disable-next-line no-case-declarations
			case 'ad_video': // 激励视频任务
				// 激励广告走聚合平台
				const ext = JSON.parse(video_model.param_ext);
				ext.app_position = '福利任务;签到模块;;视频任务;';

				this.loadMediationAd(video_model.ad_group_id, JSON.stringify(ext));

				// 标记激励视频播放位置
				this.$store.commit('welfare/task/setVideoCBConf', {
					pos: 'taskVideo',
					param: { ...task },
				});
				break;
			case 'log_in': // 连续登录任务
				this.$toast('连续登录即可领取金币');
				break;
			case 'official_account': // 关注公众号 (任务配置控制仅在ios中出现此类任务)
				this.popWxPlatformModal();
				break;
			case 'count_down_modal': // 专属任务金倒计时任务
				this.handleLimitTask(task);
				break;
			case 'listen_to_songs': // 听歌任务
				this.jumpLink(task);
				break;
			case 'click': // 点击完成类型任务
				this.$post(this.$api.UPDATE_TASK_PROGRESS_API, { taskType: task_type });
				this.refreshTaskStatus(task);
				break;
			default:
				this.jumpLink(task);
		}
	},

	...handleTaskMethods,
	// 历史任务方法
	...historyTaskMethods,
	// 一系列弹窗方法
	...handleModalMethods,

	/**
	 * @description: 观看激励视频 (20次 || 播放单个激励视频)
	 * @param { Number } type - 播放视频任务配置类型 1: 公共渠道配置 2: 私有渠道配置
	 * @param { Object } config - 播放视频配置 type == 1 时 config 传入任务配置；
	 * type == 2 时 config = { master, fill, priTaskConf } 在业务组件中组装好参数模版传入；
	 * 具体用法可以参照"幸运大转盘 FortuneWheel.vue"中的用法。
	 */

	watchVideo(...params) {
		const [type, config] = params;
		const { videoConf } = this.$store.getters;
		let conf = {};

		if (type === 2) {
			// 播放单个激励视频配置
			// this.showAdVideo({ priConf: config });
			conf = videoConf({ privateConf: config });
		} else {
			// 20次激励视频配置
			let taskConf = null;
			const { state } = this.$store;

			if (versionCompare(state.client['client-v'], '3.0.2') > -1) {
				taskConf = state.video.adrTaskAdGt302;
			} else {
				taskConf = state.video.adrTaskAd;
			}

			const { task_record_id: task_id, task_type, task_title: task_desc } = config;
			Object.assign(taskConf, { task_id, task_type, task_desc });

			// this.showAdVideo({ taskConf });
			conf = videoConf({ taskConf });
		}
		const appName = this.$store.getters.client['app-name'] || 'kuaiyin';

		if (appName === 'kuaiyinyue') {
			const { task_record_id: task_id, task_type, task_title: task_desc } = config;
			this.watchRewardVideoOnFakePackage(task_type, task_id, task_desc);
			return;
		}
		const { master, fill } = conf;
		this.$sdkNew.appCall('SHOW_REWARD_VIDEO_AD_WITH_JSON', JSON.stringify(master), JSON.stringify(fill));
	},

	/**
	 * @description: 调用客户端方法，播放激励视频
	 * @param {Object} priConf - 播放视频私域配置: { master, fill, priTaskConf }, 在业务组件中组装好参数模版传入；
	 * 具体用法可以参照"幸运大转盘 FortuneWheel.vue"中的用法。
	 * @param { Object } taskConf - 播放视频任务配置
	 */

	showAdVideo({ taskConf, priConf }) {
		const { videoConf } = this.$store.getters;
		let conf = {};

		if (priConf) {
			conf = videoConf({ privateConf: priConf });
		} else {
			conf = videoConf({ taskConf });
		}

		const { master, fill } = conf;
		this.$sdkNew.appCall('SHOW_REWARD_VIDEO_AD_WITH_JSON', JSON.stringify(master), JSON.stringify(fill));
	},

	/**
	 * @description: 播放聚合广告
	 * @param {number} groupId - 广告组ID
	 * @param {string} params - 透传业务参数
	 * return void
	 */

	loadMediationAd(groupId, params) {
		try {
			console.log(`loadMediationAd groupId =>`, groupId);
			console.log(`loadMediationAd params =>`, params);
			this.$sdkNew.appCall('LOAD_MEDIATION_AD', groupId, params);
		} catch (e) {
			console.log(e);
		}
	},

	/**
	 * @description: 登录方法
	 * return void
	 */

	login() {
		const appName = this.$store.getters.client['app-name'] || 'kuaiyin';
		this.$sdkNew.appCall('OPEN_PAGE_WITH_JSON', JSON.stringify({ url: `${appName}://login` }));
	},

	/**
	 * @description: 加载恭喜获得模块
	 * @param {object} options - 参数
	 * @param {string} options.type - 恭喜获得模块布局类型 replace or noDouble or double
	 * @param {string} options.videoOverType - 翻倍视频看完后的恭喜获得模块布局类型 replace or noDouble or double
	 * @param {string} options.rewardType - coin or musical 奖励类型 金币/音符
	 * @param {number} options.rewardAmount - 奖励数量
	 * @param {string} options.rewardTextExtra - 奖励额外文字 会拼接在'恭喜获得'之后
	 * @param {string} options.bussiness - 埋点用，传入业务名称（客户端 5.15 版本后不再用此字段）
	 * @param {string} options.position - 埋点用，传入业务位置
	 * @param {string} options.businessMain - 埋点用，传入主业务名称
	 * @param {string} options.businessSub - 埋点用，传入子业务名称
	 */

	loadCongratulationsModule(options) {
		const {
			type = 'double',
			videoOverType = 'noDouble',
			rewardType = 'coin',
			rewardAmount = 0,
			rewardTextExtra = '',
			bussiness = '',
			businessName = '',
			videoOverbusinessName = '',
			position = '',
			businessMain = '',
			businessSub = '',
		} = options;
		const version = this.$store.getters.client['client-v'];
		const appName = this.$store.getters.client['app-name'] || 'kuaiyin';
		if (versionCompare(version, '3.11.0') !== -1) {
			const data = {
				url: `${appName}://congratulationsPopWindow?type=${type}&rewardType=${rewardType}&rewardAmount=${rewardAmount}&rewardTextExtra=${rewardTextExtra}&videoOverType=${videoOverType}&bussiness=${bussiness}&businessName=${businessName}&videoOverbusinessName=${videoOverbusinessName}&position=${position}&businessMain=${businessMain}&businessSub=${businessSub}`,
			};
			this.$sdkNew.appCall('OPEN_PAGE_WITH_JSON', JSON.stringify(data));
		}
	},

	/**
	 * @description: 埋点方法（老版任务页功能埋点）
	 * @param {type} { element_name, remarks }
	 */

	trackClick({ page_title = '任务页', element_name, remarks }) {
		trackClick({
			page_title,
			element_name,
			remarks,
		});
	},

	/**
	 * @description: 检查登录状态
	 * @param { Boolean } needOpenLoginPage 是否需要跳转登录页
	 */

	checkLogin(needOpenLoginPage) {
		if (this.$store.getters.client.accessToken) {
			return true;
		}
		if (needOpenLoginPage) {
			this.login();
		}
		return false;
	},
};



// WEBPACK FOOTER //
// ./src/root/index.js